// Set by Sync together with the order it creates, or for a quote once it is paid.
export const PRETTY_PREVIEW_CLOSED_DEAL = "closed_deal";

export const PRETTY_PREVIEW_STATUSES = [
  { value: "open", label: "Open" },
  { value: PRETTY_PREVIEW_CLOSED_DEAL, label: "Closed Deal" },
  { value: "request_sent", label: "Request Sent" },
  { value: "change_request", label: "Change request" },
];
export const PRETTY_PREVIEW_AGENTS = [
  { value: "self_serving", label: "Self Serving" },
  { value: "agents", label: "Agents" },
];
export const PRETTY_PREVIEW_MAX_REQUEST = 10;
